// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3RQSS","footer":"ModalFilter_footer__193aA"};